export enum Language {
  ENGLISH = 'ENGLISH',
  PORTUGUESE = 'PORTUGUESE',
  ITALIAN = 'ITALIAN',
  GERMAN = 'GERMAN',
  FRENCH = 'FRENCH',
  CHINESE = 'CHINESE',
  JAPANESE = 'JAPANESE',
  DUTCH = 'DUTCH',
  KOREAN = 'KOREAN',
  SPANISH = 'SPANISH',
}
